import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BaseUrl } from '../App';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';



const UserProfile = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);

  const [loading, setLoading] = useState(false);


  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    password: '',
    new_password: '',
    confirm_password: ''
  });
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  
  useEffect(() => {
    const userId = sessionStorage.getItem('userId');
    if (userId) {
      fetchUserDetails(userId);
    } else {
      setLoading(false);
      setError("User ID not found. Please log in again.");
    }
  }, []);

  const fetchUserDetails = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.post(`${BaseUrl}/backend/api/profile_data.php`, {
        action: "get_profile_detail",
        api_key: "1",
        type: "user",
        user_id: userId
      });
      
      if (response.data.status === "true") {
        const userDetails = response.data.response[0];
        setFormData({
          ...formData,
          first_name: userDetails.first_name,
          last_name: userDetails.last_name,
          email: userDetails.user_email,
          phone: userDetails.phone || '',
          address: userDetails.address || '',
          city: userDetails.city || '',
          state: userDetails.state || '',
          zip: userDetails.zip || '',
          password: userDetails.user_pwd || ''
        });
      } else {
        setError("Failed to load profile data");
      }
    } catch (error) {
      setError("Error connecting to server. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    
    // Clear error for this field when user types
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateField = (name, value) => {
    switch (name) {
      case 'phone':
        return /^\d{10}$/.test(value) ? '' : 'Phone number must be exactly 10 digits';
      case 'email':
        return /\S+@\S+\.\S+/.test(value) ? '' : 'Please enter a valid email address';
      case 'zip':
        return /^\d{6}$/.test(value) ? '' : 'Zip code must be exactly 6 digits';
      case 'last_name':
        return value.length <= 13 ? '' : 'Last name cannot exceed 13 characters';
      case 'new_password':
        return value.length <= 8 ? '' : 'New password cannot be more than 8 characters';
      case 'confirm_password':
        return value === formData.new_password ? '' : 'Passwords do not match';
      default:
        return '';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Validate all fields
    Object.entries(formData).forEach(([fieldName, fieldValue]) => {
      // Skip validation for first_name since it's disabled
      if (fieldName === 'first_name') return;
      
      // Only validate password fields if changing password
      if (['new_password', 'confirm_password'].includes(fieldName) && !showChangePassword) return;
      
      const error = validateField(fieldName, fieldValue);
      if (error) {
        newErrors[fieldName] = error;
        isValid = false;
      }
    });

    setFieldErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setError("");
    setResponseMessage("");

    if (!validateForm()) {
      setError("Please fix the errors in the form before submitting.");
      return;
    }

    const userId = sessionStorage.getItem('userId');
    if (!userId) {
      setError('User ID is missing. Please log in again.');
      return;
    }

    try {
      setLoading(true);
      const updateResponse = await axios.post(`${BaseUrl}/backend/api/profile_data_update.php`, {
        action: "profile_detail_update",
        api_key: "1",
        user_id: userId,
        type: "user",
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip: formData.zip,
        // password: showChangePassword ? formData.new_password : formData.password
      });

      if (updateResponse.data.status === 'true') {
        setSuccessMessage("User Profile Updated Successfully!");
        // Reset password fields
        // if (showChangePassword) {
        //   setFormData(prev => ({
        //     ...prev,
        //     password: formData.new_password,
        //     new_password: '',
        //     confirm_password: ''
        //   }));
        //   setShowChangePassword(false);
        // }
      } else {
        setError(updateResponse.data.response || "Failed to update profile.");
      }
    } catch (error) {
      setError("Error connecting to server. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  //     </div>
  //   );
  // }

  return (
   

    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="bg-gray-50 min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-6 sm:p-8">
        {successMessage && (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6 rounded">
            <div className="flex">
              <div className="py-1">
                <svg className="h-6 w-6 text-green-500 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <p className="font-bold">Success</p>
                <p className="text-sm">{successMessage}</p>
              </div>
            </div>
          </div>
        )}

        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded">
            <div className="flex">
              <div className="py-1">
                <svg className="h-6 w-6 text-red-500 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <div>
                <p className="font-bold">Error</p>
                <p className="text-sm">{error}</p>
              </div>
            </div>
          </div>
        )}

        <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b-2 border-gray-200">Profile Information</h2>

        <form onSubmit={handleSubmit}>
          <div className="space-y-6">
            {/* Full Name Field - Disabled */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  placeholder="First Name"
                  className="w-full px-4 py-2 bg-gray-100 text-gray-700 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 cursor-not-allowed"
                  disabled
                />
                <div className="mt-1 text-xs text-amber-600">* First name cannot be updated</div>
              </div>
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                placeholder="Enter your last name"
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                  fieldErrors.last_name ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {fieldErrors.last_name && (
                <p className="mt-1 text-xs text-red-500">{fieldErrors.last_name}</p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                  fieldErrors.email ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {fieldErrors.email && (
                <p className="mt-1 text-xs text-red-500">{fieldErrors.email}</p>
              )}
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your 10-digit phone number"
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                  fieldErrors.phone ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {fieldErrors.phone && (
                <p className="mt-1 text-xs text-red-500">{fieldErrors.phone}</p>
              )}
            </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Enter your address"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                rows="3"
              />
            </div>

            {/* City, State, Zip in a grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Enter your city"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  placeholder="Enter your state"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Zip Code</label>
                <input
                  type="text"
                  name="zip"
                  value={formData.zip}
                  onChange={handleInputChange}
                  placeholder="Enter 6-digit zip code"
                  className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                    fieldErrors.zip ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {fieldErrors.zip && (
                  <p className="mt-1 text-xs text-red-500">{fieldErrors.zip}</p>
                )}
              </div>
            </div>

            {/* Change Password Button */}
            {/* <div className="pt-4">
              <button
                type="button"
                onClick={() => setShowChangePassword(!showChangePassword)}
                className="px-4 py-2 text-sm font-medium text-white bg-gray-600 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
              >
                {showChangePassword ? 'Cancel Password Change' : 'Change Password'}
              </button>
            </div> */}

            {/* Password Fields */}
            {/* {showChangePassword && (
              <div className="space-y-4 border-t border-gray-200 pt-4">
                <h3 className="text-lg font-medium text-gray-700">Change Password</h3>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Old Password</label>
                  <div className="relative">
                    <input
                      type={showOldPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="Enter your old password"
                      className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                      onClick={() => setShowOldPassword(!showOldPassword)}
                    >
                      {showOldPassword ? (
                        <EyeOffIcon className="h-5 w-5" />
                      ) : (
                        <EyeIcon className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                </div> */}

                {/* New Password */}
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                  <div className="relative">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      name="new_password"
                      value={formData.new_password}
                      onChange={handleInputChange}
                      placeholder="Enter new password (max 8 characters)"
                      className={`w-full px-4 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                        fieldErrors.new_password ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? (
                        <EyeOffIcon className="h-5 w-5" />
                      ) : (
                        <EyeIcon className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                  {fieldErrors.new_password && (
                    <p className="mt-1 text-xs text-red-500">{fieldErrors.new_password}</p>
                  )}
                </div> */}

                {/* Confirm New Password */}
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleInputChange}
                      placeholder="Confirm your new password"
                      className={`w-full px-4 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 ${
                        fieldErrors.confirm_password ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? (
                        <EyeOffIcon className="h-5 w-5" />
                      ) : (
                        <EyeIcon className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                  {fieldErrors.confirm_password && (
                    <p className="mt-1 text-xs text-red-500">{fieldErrors.confirm_password}</p>
                  )}
                </div> */}
              {/* </div>
            )} */}

            {/* Response Message */}
            {responseMessage && (
              <div className="text-center text-sm text-gray-700 py-2">{responseMessage}</div>
            )}

            {/* Submit Button */}
            <div className="flex justify-end pt-4">
              <button
                type="submit"
                className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-colors"
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Saving...
                  </span>
                ) : (
                  'Save Changes'
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
   
  </div>
  );
};

export default UserProfile;


